import moment from 'moment';

function CreateEventCtrl($scope, $state, $stateParams, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService, alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService, visibilityHelpersService) { //eslint-disable-line
  const vm = this;

  const currentUserOrganization = organizationService.getCurrentOrganization();

  vm.currentDateUTC = moment.utc();
  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.eventCurrentStep = 1;
  vm.disablePublish = false;
  vm.addEventInstance = {
    onSaving() {
      if (vm.publishing) {
        vm.savingAndPublishing = true;
      } else {
        vm.saving = true;
      }
    },
    onError() {
      vm.saving = false;
      vm.savingAndPublishing = false;
      vm.publishing = false;
    },
    onSaved(nextEvent) {
      vm.saving = false;
      vm.savingAndPublishing = false;
      vm.publishing = false;

      $state.go('app.organization.event.dashboard', {
        venueId: nextEvent.venue,
        eventId: nextEvent.id,
        organizationId: currentUserOrganization.id
      });
    },
    onNextStep(currentStep) {
      vm.eventCurrentStep = currentStep;
    },
    onPrivateChanged(isPrivate) {
      vm.disablePublish = isPrivate;
    }
  };
  vm.nextEventStep = function ($event) {
    if ($event) $event.preventDefault();

    vm.addEventInstance.nextStep();
  };
  vm.saveEvent = function ($event) {
    if ($event) $event.preventDefault();

    vm.addEventInstance.saveEvent();
  };
  vm.saveAndPublishEvent = function ($event) {
    if ($event) $event.preventDefault();

    vm.publishing = true;

    vm.addEventInstance.saveEvent({
      publish: true
    });
  };
  vm.isVenuePrivate = function () {
    if (!vm.venue) return true;

    return visibilityHelpersService.isPrivate(vm.venue);
  };

  $scope.venuePromise = _getVenue();

  const dataPromises = [
    $scope.venuePromise
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];

      vm.loading = false;
    });

  function _getVenue() {
    return sdkVenueService.readById($stateParams.venueId, {
        fields: [
          'name',
          'id',
          'enable',
          'company',
          'config',
          'tags',
          'images',
          'branding',
          'publish',
          'visibility',
          'externalSellingLink',
          'seoPathname',
          'tax',
          'tip',
          'fees',
          'eventDefault'
        ].join(',')
      })
      .catch(() => {
        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUES);
      });
  }
}

CreateEventCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService',
  'visibilityHelpersService'
];

export default CreateEventCtrl;



// WEBPACK FOOTER //
// ./src/components/createEvent/createEventCtrl.js